import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    page: "profile",
    auth: false,
    permissions: [],
    name: "",
    family: "",
    role: "",
    id: 0,
    image: "",
    all_ords: 0,
    section_ords: 0,
    orders: 0,
    customers: 0,
    daily_ords: 0,
    envelopes: 0,
    online_users: [],
    online_users_full: [],
    wildduck_token: "",
    company_name: "",
    company_logo: "",
    destination: "",
    destination2: "",
    destination3: "",
    notices: 0,
    vacations_manager: 0,
    aids_manager: 0,
    missions_manager: 0,
    tarabaris: 0,
    vacations_mali: 0,
    aids_mali: 0,
    missions_mali: 0,
  },
  getters: {
    getVacationsManager: (state) => {
      return state.vacations_manager;
    },
    getAidsManager: (state) => {
      return state.aids_manager;
    },
    getMissionsManager: (state) => {
      return state.missions_manager;
    },
    getVacationsMali: (state) => {
      return state.vacations_mali;
    },
    getAidsMali: (state) => {
      return state.aids_mali;
    },
    getMissionsMali: (state) => {
      return state.missions_mali;
    },
    getTarabaris: (state) => {
      return state.tarabaris;
    },
    getCompanyName: (state) => {
      return state.company_name;
    },
    getCompanyLogo: (state) => {
      return state.company_logo;
    },
    getWildduckToken: (state) => {
      return state.wildduck_token;
    },
    getOnlineUsers: (state) => {
      return state.online_users;
    },
    getPage: (state) => {
      return state.page;
    },
    getName: (state) => {
      return state.name;
    },
    getRole: (state) => {
      return state.role;
    },
    getPermissions: (state) => {
      return state.permissions;
    },
    getId: (state) => {
      return state.id;
    },
    getImage: (state) => {
      return state.image;
    },
    getAllOrds: (state) => {
      return state.all_ords;
    },
    getSectionOrds: (state) => {
      return state.section_ords;
    },
    getOrders: (state) => {
      return state.orders;
    },
    getCustomers: (state) => {
      return state.customers;
    },
    getDailyOrds: (state) => {
      return state.daily_ords;
    },
    getEnvelopes: (state) => {
      return state.envelopes;
    },
    getDestination: (state) => {
      return state.destination;
    },
    getDestination2: (state) => {
      return state.destination2;
    },
    getDestination3: (state) => {
      return state.destination3;
    },
    getNotices: (state) => {
      return state.notices;
    },
  },
  mutations: {
    setMissionsManager: (state, data) => {
      return (state.missions_manager = data);
    },
    setAidsManager: (state, data) => {
      return (state.aids_manager = data);
    },
    setVacationsManager: (state, data) => {
      return (state.vacations_manager = data);
    },
    setMissionsMali: (state, data) => {
      return (state.missions_mali = data);
    },
    setAidsMali: (state, data) => {
      return (state.aids_mali = data);
    },
    setVacationsMali: (state, data) => {
      return (state.vacations_mali = data);
    },
    setTarabaris: (state, data) => {
      return (state.tarabaris = data);
    },

    setPage: (state, data) => {
      return (state.page = data);
    },
    setAuth: (state, data) => {
      return (state.auth = data);
    },
    setPermissions: (state, data) => {
      return (state.permissions = data);
    },
    setId: (state, data) => {
      return (state.id = data);
    },
    setImage: (state, data) => {
      return (state.image = data);
    },
    setAllOrds: (state, data) => {
      return (state.all_ords = data);
    },
    setSectionOrds: (state, data) => {
      return (state.section_ords = data);
    },
    setOrders: (state, data) => {
      return (state.orders = data);
    },
    setCustomers: (state, data) => {
      return (state.customers = data);
    },
    setDailyOrds: (state, data) => {
      return (state.daily_ords = data);
    },
    setEnvelopes: (state, data) => {
      return (state.envelopes = data);
    },
    setDestination: (state, data) => {
      return (state.destination = data);
    },
    setDestination2: (state, data) => {
      return (state.destination2 = data);
    },
    setDestination3: (state, data) => {
      return (state.destination3 = data);
    },
    setNotices: (state, data) => {
      return (state.notices = data);
    },
  },
  actions: {
    setMissionsManager: ({ commit }, data) => {
      commit("setMissionsManager", data);
    },
    setAidsManager: ({ commit }, data) => {
      commit("setAidsManager", data);
    },
    setVacationsManager: ({ commit }, data) => {
      commit("setVacationsManager", data);
    },
    setMissionsMali: ({ commit }, data) => {
      commit("setMissionsMali", data);
    },
    setAidsMali: ({ commit }, data) => {
      commit("setAidsMali", data);
    },
    setVacationsMali: ({ commit }, data) => {
      commit("setVacationsMali", data);
    },
    setTarabaris: ({ commit }, data) => {
      commit("setTarabaris", data);
    },

    setPage: ({ commit }, data) => {
      commit("setPage", data);
    },
    setAuth: ({ commit }, data) => {
      commit("setAuth", data);
    },
    setPermissions: ({ commit }, data) => {
      commit("setPermissions", data);
    },
    setId: ({ commit }, data) => {
      commit("setId", data);
    },
    setImage: ({ commit }, data) => {
      commit("setImage", data);
    },
    setAllOrds: ({ commit }, data) => {
      commit("setAllOrds", data);
    },
    setSectionOrds: ({ commit }, data) => {
      commit("setSectionOrds", data);
    },
    setOrders: ({ commit }, data) => {
      commit("setOrders", data);
    },
    setCustomers: ({ commit }, data) => {
      commit("setCustomers", data);
    },
    setDailyOrds: ({ commit }, data) => {
      commit("setDailyOrds", data);
    },
    setEnvelopes: ({ commit }, data) => {
      commit("setEnvelopes", data);
    },
    setDestination: ({ commit }, data) => {
      commit("setDestination", data);
    },
    setDestination2: ({ commit }, data) => {
      commit("setDestination2", data);
    },
    setDestination3: ({ commit }, data) => {
      commit("setDestination3", data);
    },
    setNotices: ({ commit }, data) => {
      commit("setNotices", data);
    },
  },
});
